import { effects } from 'redux-saga'
import callWithHmac from '../effects/callWithHmac'

import { receiveClients } from '../../modules/client'
import { begin, end } from '../../modules/loading'

export default function* loadSaga(invocation, action = { payload: {} }) {
  const ids = action.payload.clientIds

  try {
    yield effects.put.resolve(begin('clients', ids))
    const result = yield effects.call(
      callWithHmac,
      invocation.getClients,
      ids,
    )

    yield effects.put.resolve(receiveClients(result.clients))
  } finally {
    yield effects.put.resolve(end('clients', ids))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/client/load.js